import { ModelFactory } from "../../ModelFactory";
export class SearchResult {
  constructor(
    public readonly id: string,
    public readonly type: string,
    public readonly displayName: string,
    public readonly customerId: string | null,
    public readonly customerDisplayName: string | null,
  ) {
  }
}

class SearchResultFactory extends ModelFactory<SearchResult> {
  protected fromJson(json: any): SearchResult {
    return new SearchResult(
      json['id'],
      json['type'],
      json['display_name'],
      json['customer'] ? json['customer']['id'] : null,
      json['customer'] ? json['customer']['display_name'] : null,
    );
  }
}
export const searchResultFactory = new SearchResultFactory();
